//coded by Narain on (11/09/2024)

import { configureStore } from '@reduxjs/toolkit';
import chatReducer from './ChatReducer';

export const store = configureStore({
  reducer: {
    chat: chatReducer,
  },
});
